import React, { useEffect, useMemo, useState } from 'react';
import { Alert, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons'; 
import { Bridge } from '@nackle/bridge';  
import auth from '../../services/authService'; 
import CourseLoader from '../../components/CourseLoader/CourseLoader';
import LessonCourse from '../../components/Lesson/Lesson';

const LessonPage = ( ) => {
    const [ token, setToken ] = useState();
    const [ hasError, setHasError ] = useState( false );
    const [ studentId, setStudentId ] = useState( '' );
    const [ studentName, setStudentName ] = useState( '' );
     
    const queryParams = new URLSearchParams( window.location.search );
    const [ locale ] = useState( queryParams.get( 'locale' ) || 'en-US' );
    const [ theme ] = useState( queryParams.get( 'theme' ) || '' );
    const [ referer ] = useState( queryParams.get( 'referer' ) || '' );
    const [ courseId ] = useState( queryParams.get( 'courseId' ) || '' );
    const [ lessonId ] = useState( queryParams.get( 'lessonId' ) || '' );
    const [ autoPlay ] = useState( queryParams.get( 'autoPlay' ) || false ); 
    const [ maximize ] = useState( queryParams.get( 'maximize' ) === 'true' || false ); 
    const [ pageTitle ] = useState( queryParams.get( 'pageTitle' ) || 'L•EARN' );
    const [ breadcrumbs ] = useState(
        queryParams.get( 'breadcrumbs' ) !== null ?  
        JSON.parse( decodeURI( queryParams.get( 'breadcrumbs' ) ) ) : [] );

    const courseOptions = useMemo( () => {
        if ( !token ) {
            return undefined;
        } else {
            return {
                token, courseId, lessonId, locale, referer, autoPlay, 
                maximize, breadcrumbs, theme, studentName, studentId
            };
        }
    }, [ token ] );
 
    useEffect( () => { 
        if ( pageTitle ) {
            document.title = pageTitle;
        }
    }, [ pageTitle ] );

    const handleSignIn = async ( authState ) => {    
        setStudentName( `${ authState.claims?.given_name || '' } ${ authState.claims?.family_name || '' }` );
        setStudentId( authState.claims?.person_id || '' );
        setToken( authState.access_token );
    };

    const handleSignInError = () => {    
        setHasError( true );
    };
     
    return (
        <div>
            { /* Loading state */ } 
            { !token && !hasError &&
                <div className="spin-page-center-container">
                    <Spin indicator={ <LoadingOutlined style={ { fontSize: 32 } } spin /> } />
                </div>
            }
            
            { /* Error state */ } 
            { hasError && 
                <Alert
                    message={ 'Session Expired' }
                    description={ 'Your session has expired. Please click back button of your browser and login again to refresh your session.' }
                    type="warning"
                /> 
            }
            
            { /* Auth */ }
            <Bridge
                auth={ auth } 
                onSignIn={ handleSignIn }
                onSignInError={ handleSignInError }
            >
                { /* Success state */ }
                { token && !hasError &&
                    <CourseLoader courseOptions={ courseOptions }>
                        <LessonCourse/>
                    </CourseLoader>
                }
            </Bridge>
        </div>
    );
};

export default LessonPage;
